import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

@Injectable()
export class LoginService {
  constructor(private http: HttpClient) { }

  getRegionsList(): Observable<any> {
    const endpoint = environment.endpointJson;

    return this.http.get(endpoint)
      .pipe(catchError(err => this.handleError(err)));
  }


  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(`
        Backend returned code ${ error.status},
        body was: ${ error.error}
      `);
    }

    return new ErrorObservable(
      'Something bad happened. Please try again later.');
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/login/login.service.ts